import { useLayoutEffect } from 'react';
import type { TooltipRenderProps } from 'react-joyride';
import { useTourPresentation } from './TourPresentationContext';

/** Joyride owns the scenario; the persistent layer owns its animated geometry. */
export default function TourTooltipBridge(props: TooltipRenderProps) {
    const presentation = useTourPresentation();
    useLayoutEffect(() => {
        if (presentation) presentation.store.publish({ tourId: presentation.tourId, props });
    }, [presentation, props]);
    return <span className="tour-tooltip-bridge" aria-hidden="true" />;
}
